// extracted by mini-css-extract-plugin
export var heroImage = "_ej-1";
export var modal = "_ej-0";